export default "__VITE_ASSET__CQMFqKWA__"